import { OfferingClient } from "../configurations/index.js";
import { PageContextUtils } from "./pageContextUtils.js";

export const hasSportOffering = () =>
  PageContextUtils.getUserData().loginPrivileges?.offerings?.some(
    offering =>
      typeof offering === "string" &&
      offering.toLowerCase() === String(OfferingClient.Sport).toLowerCase()
  );

export const hasMatchingLocation = () =>
  PageContextUtils.getUserData().loginPrivileges?.locations?.some(
    location =>
      typeof location === "string" &&
      location.toLowerCase() ===
        String(PageContextUtils.getGlobalizationData().country).toLowerCase()
  );
